<template>
  <div class="page">
    <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
      <h2 class="page-title" style="margin:0;">{{ $t('menu.handlerDisputes') }}</h2>
      <el-button @click="load" :loading="loading">{{ $t('common.refresh') }}</el-button>
    </div>

    <div class="glass-card" style="margin-top:14px;padding:14px;">
      <div style="font-family:'Poppins',sans-serif;font-weight:600;">{{ $t('status.dispute.DISPUTE_CREATED') }}</div>
      <el-table :data="poolPage" style="width:100%;margin-top:12px;" @row-click="openDetail">
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="caseNo" :label="$t('field.caseNo')" width="150" />
        <el-table-column prop="caseTitle" :label="$t('field.title')" />
        <el-table-column prop="createdAtLabel" :label="$t('field.createdAt')" width="190" />
        <el-table-column prop="status" :label="$t('field.status')" width="160">
          <template slot-scope="s">
            <span class="status-pill-wrap">
              <span :class="['tag-pill', s.row.hasReminder ? 'tag-pill--with-dot' : '']">{{ s.row.status ? $t(`status.dispute.${s.row.status}`) : '-' }}</span>
              <span v-if="s.row.hasReminder" class="status-pill-dot" />
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.actions')" width="140">
          <template slot-scope="s">
            <el-button type="primary" size="mini" class="btn-glass" @click.stop="take(s.row)">{{ $t('handler.take') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="pool.length===0" class="muted" style="margin-top:10px;">-</div>
      <div style="display:flex;justify-content:flex-end;margin-top:12px;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="pool.length"
          :page-size="pageSizePool"
          :current-page="pagePool"
          :page-sizes="[5,10,20,50]"
          @current-change="(p) => (pagePool = p)"
          @size-change="onPoolSizeChange"
        />
      </div>
    </div>

    <HandlerCaseDialog v-model="detailDialog" :case-no="currentCaseNo" @reminder-read="onReminderRead" />
  </div>
</template>

<script>
import { handlerDisputePool, takeDispute } from '../../api/disputes';
import HandlerCaseDialog from '../../components/HandlerCaseDialog.vue';

export default {
  name: 'HandlerDisputes',
  components: { HandlerCaseDialog },
  data() {
    return {
      loading: false,
      pool: [],
      pagePool: 1,
      pageSizePool: 10,
      detailDialog: false,
      currentCaseNo: ''
    };
  },
  computed: {
    version() {
      return this.$store.state.versions.disputes;
    },
    poolPage() {
      const start = (this.pagePool - 1) * this.pageSizePool;
      return (this.pool || []).slice(start, start + this.pageSizePool);
    },
  },
  watch: {
    version() {
      this.load();
    },
    detailDialog(v) {
      if (v) return;
      if (this.$route.query && this.$route.query.caseNo) {
        const q = { ...this.$route.query };
        delete q.caseNo;
        this.$router.replace({ path: this.$route.path, query: q }).catch(() => {});
      }
    },
    '$route.query.caseNo'() {
      this.maybeOpenFromQuery();
    }
  },
  created() {
    this.load();
    this.maybeOpenFromQuery();
  },
  methods: {
    maybeOpenFromQuery() {
      const caseNo = this.$route.query && this.$route.query.caseNo ? String(this.$route.query.caseNo) : '';
      if (!caseNo) return;
      this.currentCaseNo = caseNo;
      this.detailDialog = true;
    },
    onPoolSizeChange(s) {
      this.pageSizePool = s;
      this.pagePool = 1;
    },
    labelTime(ts) {
      return ts ? new Date(ts).toLocaleString() : '-';
    },
    async load() {
      if (!this.$store.state.user) return;
      this.loading = true;
      try {
        const pool = await handlerDisputePool();
        this.pool = (pool || []).map((x) => ({
          ...x,
          createdAtLabel: this.labelTime(x.createdAt)
        }));
        const maxPool = Math.max(1, Math.ceil(this.pool.length / this.pageSizePool));
        this.pagePool = Math.min(this.pagePool, maxPool);
      } finally {
        this.loading = false;
      }
    },
    openDetail(row) {
      if (!row || !row.caseNo) return;
      this.currentCaseNo = row.caseNo;
      this.detailDialog = true;
    },
    onReminderRead(caseNo) {
      if (!caseNo) return;
      this.pool = (this.pool || []).map((x) => String(x.caseNo) === String(caseNo) ? { ...x, hasReminder: false } : x);
      this.$store.dispatch('refreshHandlerBadges');
    },
    async take(row) {
      if (!row || !row.id) return;
      try {
        await takeDispute(row.id);
        await this.load();
        this.$store.commit('bumpVersion', 'disputes');
        this.$store.commit('bumpVersion', 'handlerCases');
        this.$store.dispatch('refreshHandlerBadges');
        if (row.caseNo) this.$router.push({ path: '/handler/in-progress', query: { caseNo: row.caseNo } });
        else this.$router.push('/handler/in-progress');
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.status-pill-wrap {
  position: relative;
  display: inline-block;
}
.tag-pill--with-dot {
  padding-right: 18px;
}
.status-pill-dot {
  position: absolute;
  top: 3px;
  right: 5px;
  width: 7px;
  height: 7px;
  border-radius: 99px;
  background: rgba(239, 68, 68, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.95);
}
</style>
